import script from "./onceItem2.vue?vue&type=script&setup=true&lang=js"
export * from "./onceItem2.vue?vue&type=script&setup=true&lang=js"

import "./onceItem2.vue?vue&type=style&index=0&id=1fbf6e84&lang=less"

const __exports__ = script;

export default __exports__